import { EventEmitter, Component } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { Observable } from "rxjs";

import {
  ViewService,
  SearchParams,
  CheckboxRenderer,
  CheckboxEditor,
  DeleteRowRenderer,
  AddRowHeader,
  ListViewDelegate,
  Facility,
  FacilityService,
  DatepickerEditor,
  FacilityTypeService,
} from "../common";

@Component({
  selector: "facilities-view",
  templateUrl: "./auxiliarylist-view.html",
  standalone: false,
})
export class FacilitiesView implements ListViewDelegate<Facility> {
  errorMsg: string;
  public refresh: EventEmitter<void> = new EventEmitter<void>();
  public entity: Facility;
  public sourceColumns;
  public sourceComponents;
  gridKeyColumn: string = "facilityName";
  facilityTypes: string[];

  constructor(
    public route: ActivatedRoute,
    public viewService: ViewService,
    public dataService: FacilityService,
    public facilityTypeService: FacilityTypeService
  ) {
    viewService.setViewData({
      pageTitle: "Facilities",
      link: {},
      breadcrumbs: false,
    });
    this.sourceComponents = {
      chkBoxRenderer: CheckboxRenderer,
      chkBoxEditor: CheckboxEditor,
      deleteRow: DeleteRowRenderer,
      addRow: AddRowHeader,
      datePicker: DatepickerEditor,
    };
    this.facilityTypeService.getActive().subscribe((types) => {
      this.facilityTypes = types.data.map((u) => u.name);

      this.sourceColumns = [
        {
          headerComponent: "addRow",
          headerComponentParams: { selectColumn: this.gridKeyColumn },
          cellRenderer: "deleteRow",
          maxWidth: 75,
          sortable: false,
          filter: false,
          editable: false,
        },
        {
          headerName: "Facility Name",
          field: this.gridKeyColumn,
          minWidth: 300,
          filter: "agTextColumnFilter",
          sortingOrder: ["asc", "desc"],
        },
        {
          headerName: "Company",
          field: "company",
          minWidth: 300,
          filter: "agTextColumnFilter",
          sortingOrder: ["asc", "desc"],
        },

        {
          headerName: "EPA ID",
          field: "epaid",
          minWidth: 120,
          filter: "agTextColumnFilter",
          sortingOrder: ["asc", "desc"],
        },
        {
          headerName: "Phone",
          field: "phone",
          minWidth: 120,
          filter: "agTextColumnFilter",
          sortingOrder: ["asc", "desc"],
        },
        {
          headerName: "Address",
          field: "address",
          minWidth: 400,
          filter: "agTextColumnFilter",
          sortingOrder: ["asc", "desc"],
        },
        {
          headerName: "Type",
          field: "facilityTypeName",
          minWidth: 200,
          cellEditor: "agSelectCellEditor",
          cellEditorParams: {
            values: this.facilityTypes,
          },
          filter: "agTextColumnFilter",
          sortingOrder: ["asc", "desc"],
        },
        {
          headerName: "TWS Date",
          field: "twsCheckDate",
          minWidth: 100,
          filter: "agDateColumnFilter",
          cellEditor: "datePicker",
          cellRenderer: (data) => {
            return data.value ? new Date(data.value).toLocaleDateString() : "";
          },
          sortingOrder: ["asc", "desc"],
        },
        {
          headerName: "TWS OK",
          field: "twsOk",
          minWidth: 75,
          filter: false,
          sortingOrder: ["asc", "desc"],
          cellRenderer: "chkBoxRenderer",
          cellEditor: "chkBoxEditor",
        },
        {
          headerName: "Active",
          field: "active",
          minWidth: 75,
          filter: false,
          sortingOrder: ["asc", "desc"],
          cellRenderer: "chkBoxRenderer",
          cellEditor: "chkBoxEditor",
        },
      ];
    });
  }
  performSearch(searchParams: SearchParams): Observable<Facility[]> {
    return this.dataService.all(searchParams);
  }

  save(entity: Facility) {
    this.dataService.save(entity).subscribe(
      (en) => {
        this.errorMsg = null;
        this.refreshView();
      },
      (error) => {
        this.errorMsg = error;
        this.refreshView();
      }
    );
  }

  remove(entity: Facility) {
    if (window.confirm(`Are you sure you want to remove '${entity[this.gridKeyColumn]}'?`)) {
      this.dataService.remove(entity.id).subscribe((x) => {
        this.errorMsg = null;
        this.refreshView();
      });
    }
  }

  refreshView() {
    this.refresh.emit();
  }
}
